window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    
    require('summernote');
    require('summernote/dist/summernote.js');
    require('select2');
    
//    window.Popper = require('popper.js');
//    window.Tooltip = require('tooltip.js');
  
    window.Cropper = require('cropperjs');
    
    window.datetimepicker = require('pc-bootstrap4-datetimepicker');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";
// flatpickr global verfuegbar machen (wie Calendar/marked/EasyMDE unten): die
// Inline-Init in Blade-Views ruft bare flatpickr('.flatpickr', ...) bzw.
// flatpickr.l10ns.de auf. Ohne diese Zuweisung ist flatpickr undefined →
// Date-Picker tot (z. B. Beschaffung-Feld procurement.date). Tracking SER-000630.
window.flatpickr = flatpickr;
flatpickr.l10ns.de = German;

import { Calendar } from '@fullcalendar/core';
window.Calendar = Calendar;
import bootstrapPlugin from '@fullcalendar/bootstrap';
window.bootstrapPlugin = bootstrapPlugin;
import dayGridPlugin from '@fullcalendar/daygrid';
window.dayGridPlugin = dayGridPlugin;
import timeGridPlugin from '@fullcalendar/timegrid';
window.timeGridPlugin = timeGridPlugin;
import interactionPlugin from '@fullcalendar/interaction';
window.interactionPlugin = interactionPlugin;
import listPlugin from '@fullcalendar/list';
window.listPlugin = listPlugin;
import deLocale from '@fullcalendar/core/locales/de';
window.deLocale = deLocale;

import { marked } from 'marked';
window.marked = marked;

import EasyMDE from 'easymde';
import 'easymde/dist/easymde.min.css';
window.EasyMDE = EasyMDE;

import { fetchEventSource } from '@microsoft/fetch-event-source';
window.fetchEventSource = fetchEventSource;

import Asciidoctor from '@asciidoctor/core'
window.asciidoctor = Asciidoctor();

import hljs from 'highlight.js';
import 'highlight.js/styles/github.css'; 
window.hljs = hljs;
window.hljs.highlightAll();

import Chart from 'chart.js/auto';
window.Chart = Chart;

//import { createPopper } from '@popperjs/core';
//window.createPopper = createPopper;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Wird benötigt für die Cockpit-
 * Live-Counter-Updates (Sub-Ticket SER-000451). Echtzeit läuft on-premise
 * über Laravel Reverb (SER-000838), Pusher-Protokoll-kompatibel. Init ist
 * defensiv: ohne MIX_REVERB_*-ENV (z. B. lokal/Dev) bleibt Echo undefined
 * und das übrige UI läuft ohne Live-Updates weiter.
 */
try {
    const reverbKey = (typeof process !== 'undefined' && process.env && process.env.MIX_REVERB_APP_KEY) || '';
    const reverbHost = (typeof process !== 'undefined' && process.env && process.env.MIX_REVERB_HOST) || '';
    const reverbPort = Number((typeof process !== 'undefined' && process.env && process.env.MIX_REVERB_PORT) || 443);
    const reverbScheme = (typeof process !== 'undefined' && process.env && process.env.MIX_REVERB_SCHEME) || 'https';

    // Nur initialisieren, wenn ein On-premise-Endpunkt konfiguriert ist.
    if (reverbKey && reverbHost) {
        const Echo = require('laravel-echo').default;
        const Pusher = require('pusher-js');
        window.Pusher = Pusher;

        // laravel-echo 1.x kennt den 'reverb'-Broadcaster noch nicht; Reverb ist
        // jedoch Pusher-Protokoll-kompatibel → 'pusher'-Treiber mit eigenem
        // wsHost/wsPort. disableStats unterbindet Telemetrie an pusher.com.
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: reverbKey,
            wsHost: reverbHost,
            wsPort: reverbPort,
            wssPort: reverbPort,
            forceTLS: reverbScheme === 'https',
            enabledTransports: ['ws', 'wss'],
            disableStats: true,
            authEndpoint: '/broadcasting/auth',
            auth: {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            },
        });
    }
} catch (e) {
    // Echo bleibt undefined → Cockpit-Live-Updates werden im Frontend
    // übersprungen, alles Übrige funktioniert weiter.
    if (typeof console !== 'undefined' && console.warn) {
        console.warn('Laravel Echo (Reverb) konnte nicht initialisiert werden:', e && e.message);
    }
}